export const CitadeleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g id="Citadele">
        <rect id="Rectangle 486" width="40" height="40" rx="4" fill="#E21635" />
        <g id="Group 7396">
          <rect
            id="Rectangle 368"
            x="11.667"
            y="14.1666"
            width="16.6667"
            height="4.08333"
            fill="white"
          />
          <rect
            id="Rectangle 369"
            x="11.667"
            y="21.7499"
            width="16.6667"
            height="4.08333"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};
